
// Import required components and assets for the Services page
import Hero from "../components/Hero";
import HeroImage from "../../assets/images/Services1.png";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/Logo-light 1.png";
import Button from "../components/Button";
import service1 from "../../assets/images/Services 2.png";
import service2 from "../../assets/images/Homepage 3.png";
import service3 from "../../assets/images/Services 4.png";
import "../../css/Services.css";
import ButtonSecondary from "../components/ButtonSecondary";
import servicesDarkBackground from "../../assets/images/BG_Services1.jpg";
import servicesLightBackground from "../../assets/images/BG_Services2.jpg";


/**
 * ServicesPage component displays the main services offered by Oakmont Financial Services.
 *
 * Sections:
 * - Hero: Top banner with title and call-to-action button
 * - Mortgages: Information and CTA for mortgage services
 * - Personal Protection: Information and CTA for protection products
 * - Equity Release: Information and CTA for equity release services
 *
 * Uses:
 * - Hero, Button, ButtonSecondary components
 * - React Router's useNavigate for navigation
 * - CSS backgrounds and images for visual sections
 */
const ServicesPage = () => {
  // React Router hook for navigation
  const navigate = useNavigate();
  return (
    <div>
      {/* Hero section with title and consultation button */}
      <Hero
        title={"Our Services"}
        // subtitle={"Independent Mortgage  and Protection Adviser"}
        backgroundImage={HeroImage}
        titleAlign="center"
        subtitleAlign="center"
        buttonText="BOOK A CONSULTATION"
        onButtonClick={() => {
          navigate("/contact");
        }}
        // logo={logo}
      />
      <div className="services-page">
        {/* Mortgages section */}
        <div
          className="service-row1 "
          id="mortgages"
          style={{
            backgroundImage: `url(${servicesDarkBackground})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="service-row-content">
            <div className="service-text">
              <div className="subtitle-semibold">Mortgages</div>
              <div>
                Whether you are a first-time buyer, looking to remortgage, or
                want to build on your buy to let portfolio. At Oakmont we can
                help you. With our years of experience finding people mortgages,
                you could be next.
              </div>
              <div>
                With so many mortgages available knowing where to start and
                finding the right one for you can be tricky. By booking an
                appointment with us we can get a better idea of your specific
                circumstances, and help set out a plan to find a deal that fits
                you.
              </div>
              <div className="content-small-italic">
                Your home may be repossessed if you do not keep up repayments on
                your mortgage.
              </div>
              {/* Button to contact page for mortgage inquiries */}
              <ButtonSecondary
                text="Contact Us"
                onClick={() => {
                  navigate("/contact");
                }}
              />
            </div>
            <div className="service-image">
              {/* Mortgage service illustration */}
              <img src={service1} alt="Commercial Financial advice" />
            </div>
          </div>
        </div>
        {/* Personal Protection section */}
        <div
          className="service-row1 light"
          id="personal-protection"
          style={{
            backgroundImage: `url(${servicesLightBackground})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="service-row-content">
            <div className="service-image">
              {/* Personal protection illustration */}
              <img src={service3} alt="Personal Protection" />
            </div>
            <div className="service-text">
              <div className="subtitle-semibold">Personal Protection</div>
              <div>
                There is no one size fits all solution when it comes to
                protecting the things that matter, which is why we’re here to
                help guide you to the right product – ensuring you’re covered
                regardless of what comes your way.
              </div>
              {/* Button to contact page for protection inquiries */}
              <Button
                text="Contact Us"
                onClick={() => {
                  navigate("/contact");
                }}
              />
            </div>
          </div>
        </div>
        {/* Equity Release section */}
        <div
          className="service-row1"
          id="equity-release"
          style={{
            backgroundImage: `url(${servicesDarkBackground})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="service-row-content">
            <div className="service-text">
              <div className="subtitle-semibold">Equity Release</div>
              <div>
                Equity Release can allow you to ‘unlock’ tax-free funds that are
                tied up in your property, without moving or selling.
              </div>
              <div>
                You do have to meet specific criteria to apply and it may not
                always be the best solution for your circumstances, so in a chat
                with us we can discuss it further and help you find the right
                plan.
              </div>
              <div className="content-small-italic">
                Equity release will reduce the value of your estate and can
                affect your eligibility for means tested benefits.
              </div>
              {/* Button to contact page for equity release inquiries */}
              <ButtonSecondary
                text="Contact Us"
                onClick={() => {
                  navigate("/contact");
                }}
              />
            </div>
            <div className="service-image">
              {/* Equity release illustration */}
              <img src={service2} alt="Commercial Financial advice" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


// Export the ServicesPage component as default
export default ServicesPage;
